module.exports = __webpack_public_path__ + "img/ao.5b862483.svg";